import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "login";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    account: {
      api: {
        headers: {
          'Content-Type': 'application/json',
          'moduleCode': setup.setup.thor.moduleCode,
          'token': null
        },
        endpoints: {
          auth: {
            doc: 'https://countdown-uat.txweb.site/login',
            url: setup.setup.api.countdown_v1.url[environment] + '/login',
           
            method: 'POST'
          },
          detail: {
            doc: 'https://countdown-uat.txweb.site/members/enquiry',
            url: setup.setup.api.countdown_v1.url[environment] + '/members/enquiry',
            method: 'GET'
          },
          captcha: {
            doc: 'https://countdown-uat.tr4ns.com/recaptcha',
            url: setup.setup.api.countdown_v1.url.captcha + '/recaptcha?token=',
            method: 'GET'
          }
        }
      },
      objects: {
        username: { name: "username", initial: "",label2:"card number", label: "Card number", helperText: false, rules: ["isRequired"], allow_null: false, minmax_limit: 16, minmax_suffix: "" },
        password: { name: "password", initial: "", label: "Password",  label2:"Password", helperText: false, rules: ["isMin"], allow_null: false ,limit: 4, minmax_suffix: "digit password"},
      },
      responses: {
        "fail": "Incorrect card number or PIN"
      }
    }
  },
  routes: {
    label: "Login",
    prefix: "/u/login"
  },
  setup,
  environment
}

export default config;
